export function selectBestTab<TId extends string>(
  priorityOrder: TId[],
  hasContent: Record<TId, boolean>,
  preferredTab: TId
): TId | null {
  if (hasContent[preferredTab]) return preferredTab

  for (const id of priorityOrder) {
    if (hasContent[id]) return id
  }

  return null
}
